import { Response } from '@angular/http';

import { ErrorTypeEnum } from '../shared/enums.model';
import { ErrorObject } from './gpiserror-object';
import { ErrorHandlerLogService } from './gpiserror-error-log.service';
import { ErrorHandlerService } from './gpiserror-handler.service';
import { ErrorHandler } from '@angular/core';

export class GpisErrorHandler extends ErrorHandler {
    errLogger: ErrorHandlerLogService = new ErrorHandlerLogService();

    constructor(private globalErrHandlerService: ErrorHandlerService) {
        super( false );
    }

    handleError( error: any ) {
        try {
            let eObj: ErrorObject;
            if (typeof error == "string") {
                eObj = new ErrorObject( error, 'Unknown source', ErrorTypeEnum.Error );
            } else if ( error instanceof ErrorObject ) {
                let errorObject: ErrorObject = error;
                eObj = <ErrorObject>error;
            } else if ( error instanceof Response ) {
                eObj = this.responseError(error);
            } else if ( error._nativeError === "undefined" || error._nativeError == null) {
                eObj = this.messageError(error.message);
            } else { 
                let errMsg: string = 'Unexpected error, please notify Scania IT support. The error text is: ' +
                    error._nativeError.message;
                let originator = error._nativeError.stackTrace;
                eObj = new ErrorObject(error, originator, ErrorTypeEnum.Error);
            }

            this.globalErrHandlerService.emitErrorObject( eObj );
            this.logError(error);
        }

        catch (Error) {
            console.log(Error);
        }
    }

    private responseError(error: Response): ErrorObject {
        const body = typeof error.json === "function" ? error.json() || {} : {};
        const err = body.error || JSON.stringify( body );
        let errMsg: string = `${error.status} - ${error.statusText || ''} ${err}`;
        let source: string = `API - ${error.url || ''}`;
        return new ErrorObject( errMsg, source, ErrorTypeEnum.Error );
    }

    private messageError(message: string): ErrorObject {
        // const body = typeof error.json === "function" ? error.json() || {} : {};
        // const err = body.error || JSON.stringify( body );
        // let errMsg: string = `${error.status} - ${error.statusText || ''} ${err}`;
        // let source: string = `API - ${error || ''}`;
        return new ErrorObject( message, "source", ErrorTypeEnum.Error );
    }

    logError (error: ErrorObject ) {
        this.errLogger.logError(error);
    }
}




// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/errorhandler/gpiserror-handler.ts